import React from 'react'
import CommonSectionCategory from '../../../Shared/CommonSectionCategory';
import { categoryModel } from '../../../Model/categoryCons';

const TravelAndAdventureCategory = () => {
    return (
        <>
            <CommonSectionCategory props={categoryModel.TravelAndAdventure} />
        </>
    )
}

export default TravelAndAdventureCategory;